import React from "react";
import Select from "react-select";
import { ImSpinner2 } from "react-icons/im";
import { AiFillDelete } from "react-icons/ai"; // Only need delete icon here
import { BiSolidCity } from "react-icons/bi";
import empty from "../../../../../../assets/images/empty.png"; // Re-add empty image

export const CarCategories = ({
  selectedCity,
  setSelectedCity,
  citiesDataForSelect, // Renamed from citiesData to match AdminCarRates
  isLoading,
  currentCity,
  setIsCarDetailModalOpen,
  setCurrentCar,
  handleDeleteCar, // Receive the handler as a prop
}) => {
  return (
    <div>
      <div className="mt-5">
        {/* City Select */}
        <div className="lg:w-[30%] w-full flex flex-col gap-y-1">
          <label htmlFor="service" className="text-sm">
            Select City
          </label>
          <div className="flex h-11 items-center border-[0.3px] bg-transparent focus:outline-none border-gray-400 py-2 px-2 gap-x-2 w-full rounded-lg">
            <div className="w-[5%]">
              <BiSolidCity size={16} className="text-gray-500" />
            </div>

            <div className="w-[95%] text-shuttlelaneBlack text-sm relative z-[90]">
              <Select
                value={selectedCity}
                onChange={(value) => {
                  setSelectedCity(value);
                }}
                options={citiesDataForSelect} // Use the prop
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "transparent"
                      : "transparent",
                    borderWidth: state.isFocused ? "0" : "0",
                    backgroundColor: "transparent",
                    position: "relative",
                  }),
                  placeholder: (baseStyles) => ({
                    ...baseStyles,
                    fontSize: ".875rem",
                  }),
                  menuList: (baseStyles) => ({
                    ...baseStyles,
                    fontSize: ".875rem",
                  }),
                  input: (baseStyles) => ({
                    ...baseStyles,
                    fontSize: ".875rem",
                  }),
                }}
                placeholder="Select City"
              />
            </div>
          </div>
        </div>
      </div>

      {isLoading && (
        <div className="flex flex-col gap-y-5 mt-5 w-full items-center">
          {" "}
          {/* Added items-center for spinner */}
          <ImSpinner2
            size={20}
            className="text-shuttlelanePurple animate-spin"
          />
        </div>
      )}

      {/* CARS TABLE */}
      {!isLoading && (
        <div className="mt-5 w-full lg:overflow-x-hidden overflow-x-scroll shuttlelaneScrollbarHoriz shuttlelaneScrollbar">
          {/* Table header */}
          <div className="maxContent lg:max-w-full lg:min-w-full flex justify-between items-baseline mb-2 border-b-[.3px] border-b-gray-100 text-gray-400 mt-2">
            <p className="w-[200px] lg:w-[33.3%] text-xs">Car Name</p>
            <p className="w-[200px] lg:w-[33.3%] text-xs">Price per day</p>
            <p className="w-[200px] lg:w-[33.3%] text-xs">Actions</p>
          </div>

          {/* Table body */}
          {currentCity?.cars?.length > 0 ? ( // Check if cars exist
            currentCity.cars.map((car) => (
              <div
                key={car._id} // Added key for list rendering
                className="flex maxContent cursor-pointer lg:max-w-full lg:min-w-full justify-between items-baseline mb-2 pb-2 border-b-[.3px] border-b-gray-100 text-shuttlelaneBlack mt-4"
              >
                <p
                  onClick={() => {
                    setIsCarDetailModalOpen(true);
                    setCurrentCar(car);
                  }}
                  className={`w-[200px] lg:w-[33.3%] text-xs ${
                    isLoading && "text-gray-400"
                  }`}
                >
                  {car?.name}
                </p>
                <p
                  onClick={() => {
                    setIsCarDetailModalOpen(true);
                    setCurrentCar(car);
                  }}
                  className={`w-[200px] lg:w-[33.3%] text-xs ${
                    isLoading && "text-gray-400"
                  }`}
                >
                  ₦{Intl.NumberFormat("en-US", {}).format(car?.price)}
                </p>

                <p
                  className={`w-[200px] lg:w-[33.3%] text-xs ${
                    isLoading && "text-gray-400"
                  }`}
                >
                  <AiFillDelete
                    onClick={() => {
                      // Pass car._id and car.city for deletion
                      handleDeleteCar(car._id, car.city);
                    }}
                    size={16}
                    className="text-red-500"
                  />
                </p>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center gap-y-5 text-center mt-10">
              <img
                src={empty}
                className="max-w-[150px] w-[150px] object-contain"
                alt="No cars to show for now"
              />
              <p className="text-center text-sm">No cars to show for now...</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
